import React, { useCallback } from 'react';

import { advanceReadCursor } from '../../lib/read_cursor';

const UnreadMarker = ({ workspaceId, channelId, profileId, onDismiss }) => {
  const dismissUnreadMarker = useCallback(() => {
    if (!channelId) return;
    void advanceReadCursor(workspaceId, channelId, profileId, 'dismiss-unread-marker', { forceNetwork: true });
    onDismiss?.();
  }, [workspaceId, channelId, profileId, onDismiss]);

  return (
    <div className="absolute -top-1 right-0 z-(--stack-messages-unread-marker) md:-right-1">
      <button
        onClick={dismissUnreadMarker}
        data-app-region="none"
        className="cursor-pointer rounded-md bg-pink-500 px-1 py-2 text-[8px] font-bold text-white ring ring-gray-50 dark:ring-neutral-950"
      >
        NEW
      </button>
    </div>
  );
};

export default UnreadMarker;
